import Agent from '../Agent';
import { type AgentParams, type AgentInstances } from '../Agent';

class NewPositioningModelAgent extends Agent {
  static name = 'Strategy::NewPositioningModelAgent';

  static publicName = 'Positioning Model';

  static available(
    agentParams: AgentParams,
    agentInstances: AgentInstances
  ): boolean {
    if (
      !window.currentAccount?.hasGeneralAiAssistant ||
      !window.featureFlags.ACT_18744_ai_strategy_items
    ) {
      return false;
    }

    if (agentParams.autoLoaded === this.name) {
      return true;
    }
    return false;
  }

  static initialPrompt(): string | null {
    return 'Draft positioning';
  }
}

Agent.register(NewPositioningModelAgent);

export default NewPositioningModelAgent;
